import * as React from 'react';
import MaskedInput, { MaskedInputProps } from 'react-text-mask';

const MaskedInputWithRef = React.forwardRef<HTMLInputElement, MaskedInputProps>(
  (props, ref) => <MaskedInput {...props} />
);
MaskedInputWithRef.displayName = 'MaskedInputWithRef';

export { MaskedInputWithRef };
